import React from 'react';
import { Loader } from '@oforce/global-components';

export default function BoxLoader() {
  return <Loader />;
}
